<div *ngIf="task; else no_task">

    <ng-container *ngIf="data">
        <h2 *ngIf="task.isProcess;else Zoning_code_statistic" mat-dialog-title>{{ task.typeStr }}</h2>
        <h4 *ngIf="task.isProcess">Statistic:</h4>
    </ng-container>

    <div class="mat-typography">
        <div class="mat-typography content">
            <app-process-status-row [process]="task"></app-process-status-row>
            <app-process-statistic-section [process]="task"></app-process-statistic-section>

            <div *ngIf="task.statsByStatus">
                <app-process-stats-by-status-section [process]="task"
                    [showRatio]="true"></app-process-stats-by-status-section>
                <div class="open-chart" (click)="isOpenChart = !isOpenChart">
                    <mat-icon class="open-arrow" [class.arrow-rotate]="isOpenChart">chevron_right</mat-icon>
                    <span>Chart</span>
                </div>
                <radio-bar-chart [chartData]="task.statsByStatus" *ngIf="isOpenChart"></radio-bar-chart>
            </div>

            <br *ngIf="task.statsByActuality">
            <p *ngIf="task.statsByActuality" style="margin-bottom: 0px">Statistic by actuality: {{
                task.totalPropertyRecords}}
            </p>
            <div *ngIf="task.statsByActuality">
                <div *ngFor="let actuality of task.statsByActuality">
                    {{ getCalculationStatusActualityById(actuality.actuality) }}: {{ actuality.count }}
                </div>
            </div>

            <p *ngIf="task.messages && task.messages.length" style="margin-bottom: 0px">Messages:</p>
            <div *ngIf="task.messages && task.messages.length" class="scrollableMessages">
                <mat-list>
                    <ng-container *ngFor="let message of task.messages">
                        <p>{{message}}</p>
                    </ng-container>
                </mat-list>
            </div>

            <div *ngIf="task.performance">
                <h3 mat-dialog-title style="font-weight: bold;">Performance statistic</h3>
                <app-task-performance-details [task]="task"></app-task-performance-details>
            </div>

            <app-prs-bunch-size-slider [task]="task" *ngIf="!task.isArchived">
            </app-prs-bunch-size-slider>

            <div *ngIf="task?.solrGroupIdsStatistic">
                <h3 class="md-subhead" style="font-weight: bold;">Synchronization with Solr -
                    <app-solr-operations-status [data]="task?.solrGroupIdsStatistic"></app-solr-operations-status>
                </h3>
                <app-solr-group-ids-data-statistic [data]="task?.solrGroupIdsStatistic">
                </app-solr-group-ids-data-statistic>
            </div>

            <div class="open-chart" *ngIf="!hidePRThreadsList" (click)="isOpenPRThreadsLits = !isOpenPRThreadsLits">
                <mat-icon class="open-arrow" [class.arrow-rotate]="isOpenPRThreadsLits">chevron_right</mat-icon>
                <span>Property Records</span>
            </div>
            <app-pr-threads-list [prThreadsData]="task.prThreadsData" *ngIf="isOpenPRThreadsLits && !hidePRThreadsList">
            </app-pr-threads-list>
        </div>
    </div>
</div>

<ng-template #no_task>
    <h2>Task not found</h2>
</ng-template>

<ng-template #Zoning_code_statistic>
    <h2>Zoning code statistic</h2>
</ng-template>